export enum WarehouseReceiptStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
}
